import React, { useState } from 'react';

const Withdraw = () => {
  const [amount, setAmount] = useState('');
  const [address, setAddress] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [activeTab, setActiveTab] = useState('withdraw');

  // Static history for display (as no API exists yet)
  const history = [
    { id: 'W001', date: '2024-01-14', amount: '$300.00', address: '0x1234...5678', fee: '$2.50', status: 'pending' },
    { id: 'W002', date: '2024-01-10', amount: '$150.00', address: '0x1234...5678', fee: '$2.50', status: 'success' },
    { id: 'W003', date: '2024-01-05', amount: '$500.00', address: '0x1234...5678', fee: '$2.50', status: 'success' },
  ];

  const FEE = 2.50;
  const MIN_WITHDRAW = 10;
  const netAmount = amount && parseFloat(amount) > 0 ? (parseFloat(amount) - FEE).toFixed(2) : '0.00';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount || parseFloat(amount) < MIN_WITHDRAW) {
      alert(`Minimum withdrawal is $${MIN_WITHDRAW}`);
      return;
    }
    if (!address) {
      alert('Please enter your wallet address');
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      alert('Withdrawal request submitted!');
      setSubmitting(false);
      setAmount('');
      setAddress('');
    }, 1500);
  };

  return (
    <div className="page-wrapper">
      {/* Header */}
      <div className="page-header mb-4">
        <div className="section-label">Transfer</div>
        <h2 className="page-title">Withdraw</h2>
        <p className="page-subtitle">Transfer your earnings to your wallet</p>
      </div>

      {/* Quick Stats */}
      <div className="row g-3 mb-4">
        {[
          { label: 'Available Balance',   value: '$1,250.00',   icon: 'bi-wallet2',          color: 'green' },
          { label: 'Pending Withdrawal',  value: '$300.00',     icon: 'bi-clock-history',    color: 'yellow' },
          { label: 'Total Withdrawn',     value: '$2,850.00',   icon: 'bi-box-arrow-up-right', color: 'blue' },
        ].map((card, i) => (
          <div key={i} className="col-md-4">
            <div className={`metric-card ${card.color}`}>
              <div className={`metric-icon ${card.color}`}><i className={`bi ${card.icon}`}></i></div>
              <div>
                <div className="metric-label">{card.label}</div>
                <div className="metric-value">{card.value}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4">
        {/* Withdrawal Form */}
        <div className="col-lg-5">
          <div className="p-card">
            <p className="section-label">New Request</p>
            <h5 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Withdraw Funds</h5>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="p-label">Wallet Address (USDT TRC-20)</label>
                <div className="address-box">
                  <i className="bi bi-wallet2" style={{ color: 'rgba(255,255,255,0.3)', flexShrink: 0 }}></i>
                  <input
                    type="text"
                    value={address}
                    onChange={e => setAddress(e.target.value)}
                    placeholder="Enter your TRC-20 address..."
                    style={{ background: 'transparent', border: 'none', color: 'white', flex: 1, outline: 'none', fontSize: '0.85rem', fontFamily: 'JetBrains Mono, monospace' }}
                  />
                </div>
              </div>

              <div className="mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <label className="p-label mb-0">Amount (USDT)</label>
                  <span style={{ fontSize: '0.78rem', color: 'var(--text-secondary)' }}>Min: ${MIN_WITHDRAW}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', background: 'rgba(255,255,255,0.04)', borderRadius: 14, border: '1px solid rgba(255,255,255,0.1)', overflow: 'hidden', padding: '0 1rem' }}>
                  <span style={{ color: 'var(--page-accent)', fontWeight: 800, fontSize: '1.1rem', marginRight: 8 }}>$</span>
                  <input
                    type="number"
                    value={amount}
                    onChange={e => setAmount(e.target.value)}
                    placeholder="0.00"
                    style={{ background: 'transparent', border: 'none', color: 'white', fontSize: '1.3rem', padding: '0.9rem 0', fontFamily: 'JetBrains Mono, monospace', fontWeight: 700, flex: 1, outline: 'none' }}
                  />
                </div>
              </div>

              {/* Fee Breakdown */}
              <div style={{ background: 'rgba(255,255,255,0.02)', borderRadius: 14, padding: '1rem 1.2rem', marginBottom: '1.5rem', border: '1px solid rgba(255,255,255,0.06)' }}>
                {[
                  { label: 'Withdrawal Amount', value: `$${amount || '0.00'}` },
                  { label: 'Network Fee',       value: `-$${FEE}`, color: 'var(--page-danger)' },
                  { label: 'You Receive',       value: `$${netAmount}`, color: 'var(--page-accent)', bold: true },
                ].map((row, i) => (
                  <div key={i} className="info-row">
                    <span className="i-label">{row.label}</span>
                    <span className="i-value" style={{ color: row.color || 'white', fontFamily: 'JetBrains Mono, monospace', fontWeight: row.bold ? 800 : 600 }}>
                      {row.value}
                    </span>
                  </div>
                ))}
              </div>

              <div style={{ background: 'rgba(255,77,109,0.06)', borderRadius: 12, padding: '0.8rem 1rem', marginBottom: '1.5rem', border: '1px solid rgba(255,77,109,0.2)' }}>
                <p className="mb-0" style={{ fontSize: '0.8rem', color: 'rgba(255,120,140,0.9)', fontWeight: 600 }}>
                  <i className="bi bi-shield-exclamation me-2"></i>
                  Only send to a USDT TRC-20 address. Withdrawals are irreversible.
                </p>
              </div>

              <button type="submit" className="btn btn-gradient w-100" disabled={submitting} style={{ borderRadius: 14, padding: '0.9rem', fontWeight: 700, fontSize: '1rem' }}>
                {submitting
                  ? <><span className="spinner-border spinner-border-sm me-2"></span>Processing...</>
                  : <><i className="bi bi-arrow-up-circle me-2"></i>Submit Withdrawal</>
                }
              </button>
            </form>
          </div>
        </div>

        {/* History */}
        <div className="col-lg-7">
          <div className="p-card">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <p className="section-label mb-0">Transactions</p>
                <h5 style={{ margin: 0, fontWeight: 700 }}>Withdrawal History</h5>
              </div>
              <span style={{ fontSize: '0.78rem', background: 'rgba(255,255,255,0.05)', padding: '4px 10px', borderRadius: 20, color: 'var(--text-secondary)' }}>
                {history.length} records
              </span>
            </div>

            <div className="p-table-wrap">
              <table className="p-table">
                <thead>
                  <tr><th>ID</th><th>Amount</th><th>Address</th><th>Fee</th><th>Date</th><th>Status</th></tr>
                </thead>
                <tbody>
                  {history.map(item => (
                    <tr key={item.id}>
                      <td className="mono dim">#{item.id}</td>
                      <td style={{ fontWeight: 700, color: 'var(--page-accent)' }}>{item.amount}</td>
                      <td><span className="u-code" style={{ fontSize: '0.75rem' }}>{item.address}</span></td>
                      <td className="dim">{item.fee}</td>
                      <td className="dim" style={{ fontSize: '0.8rem' }}>{item.date}</td>
                      <td><span className={`s-pill ${item.status === 'success' ? 'success' : 'pending'}`}>{item.status}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Info Card */}
          <div className="p-card mt-4" style={{ background: 'linear-gradient(135deg, rgba(0,212,255,0.05), rgba(0,255,149,0.03))', borderColor: 'rgba(0,212,255,0.2)' }}>
            <p className="section-label">Withdrawal Policy</p>
            <div className="row g-3">
              {[
                { icon: 'bi-clock',     title: 'Processing Time', desc: '1–24 hours for approval' },
                { icon: 'bi-shield',    title: 'Security',        desc: 'Manual review for safety' },
                { icon: 'bi-calendar',  title: 'Schedule',        desc: 'Anytime, 24/7' },
                { icon: 'bi-cash-coin', title: 'Min Withdrawal',  desc: `$${MIN_WITHDRAW} USDT` },
              ].map((info, i) => (
                <div key={i} className="col-6">
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <i className={`bi ${info.icon}`} style={{ fontSize: '1.1rem', color: 'var(--page-blue)', flexShrink: 0 }}></i>
                    <div>
                      <div style={{ fontSize: '0.82rem', fontWeight: 700, color: 'white' }}>{info.title}</div>
                      <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>{info.desc}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Withdraw;